<template>
    <div class="travel">
        <div class="search">
            <el-form :inline="true" :model="searchDatas" ref="searchDatas" :rules="rules" class="demo-form-inline">
                <el-form-item label="名称" prop="name">
                    <el-input v-model="searchDatas.name" placeholder="请输入名称"></el-input>
                </el-form-item>
                <el-form-item label="游记标签">
                    <div style="width: 300px;height: 30px;">
                        <treeselect
                                :multiple="true"
                                :options="tagsOptions"
                                :normalizer="normalizer"
                                :default-expand-level="0"
                                :disable-branch-nodes="true"
                                :load-options="loadOptions"
                                :show-count="true"
                                v-model="searchDatas.tags"
                                @select="treeSelected"
                                @input="noteTagsChanges"
                                :noResultsText="noResultsText"
                                :valueFormat="valueFormat"
                                :beforeClearAll="beforeClearAll"
                                :clearAllText="clearAllText"
                                :noOptionsText="noOptionsText"
                                placeholder="请选择关联标签"
                        />
                    </div>

                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="getListData('searchDatas')">搜索</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="table">
            <el-table
                    id="etable"
                    border
                    :data="tableData"
                    size="mini "
                    height="350"
                    :header-cell-style="tableHeaderColor"
                    @selection-change="handleSelectionChange"
                    style="borderRadius:5px; margin: auto"
            >
                <el-table-column
                        type="selection"
                        width="40">
                </el-table-column>
                <el-table-column
                        label="推荐指数"
                        width="200">
                    <template slot-scope="scope">
                        <el-input-number
                                v-model="scope.row.num"
                                :min="1" :max="5"></el-input-number>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="title"
                        label="名称"
                        align="center"
                >
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                        background
                        small
                        layout="total, prev, pager, next, jumper"
                        :total="total"
                        :page-size="size"
                        :current-page="page"
                        @current-change="currentChange"
                ></el-pagination>
            </div>
        </div>

        <div class="btn">
            <el-button @click="doClose">取 消</el-button>
            <el-button type="primary" @click="doSubmit">确 定</el-button>
        </div>
    </div>

</template>
<script>
    import Treeselect from "@riophae/vue-treeselect";
    export default {
        props: ["addType", 'areaCode','id'],
        components: {Treeselect},
        data() {
            return {
                tableHeaderColor({row, column, rowIndex, columnIndex}) {
                    if (rowIndex === 0) {
                        return "  background-color: #e9eef3;border-color: #fff;ont-weight: bold;color: #515a6e;";
                    }
                },
                total: 10,
                size: 10,
                page: 1,
                tableData: [],
                recommendThematicDTOList: [],//列表选择的项

                searchDatas: { // 按照区域搜索
                    name: '',
                    tags: []
                },
                rules: {
                    name: [
                        {max: 20, message: '长度在 1 到 10 个字符', trigger: 'blur'},
                        {
                            type: "string",
                            pattern: this.regex.chennum_,
                            message: "请输入正确的名称",
                            trigger: "blur"
                        },
                        {
                            type: "string",
                            pattern: this.regex.illcharacter,
                            message: "含有非法字符",
                            trigger: "blur"
                        }
                    ],
                },

                tagsOptions: [],
                normalizer(node) {
                    return {
                        id: node.name,
                        label: node.name,
                        children:
                            node.children && node.children.length > 0
                                ? node.children
                                : node.level == 1
                                ? null
                                : "null"
                    };
                },
                noResultsText: "没有您要搜索的标签",
                valueFormat: "name",
                clearAllText: "清除全部",
                noOptionsText: "暂无数据",

            };
        },
        methods: {
            addOrEdit() { // 列表数据
                let arr = []
                if(this.searchDatas.tags){
                    this.searchDatas.tags.forEach(item => {
                        arr.push(item.name)
                    })
                }
                let addType = this.addType
                let sortUrl = '/wtcp-selftourism/selfDestinationInfo/select/findSelectNotesPage'
                let  sortParams = {
                    title: this.searchDatas.name,
                    destId:this.id,
                    tag:arr.length?arr.join(','):null,
                    size:10
                }
                this.request.get(sortUrl, {...sortParams, page: this.page}).then((res) => {
                    if (res.status === 1) {
                        res.data.content.forEach(item => {
                            item.num = 1
                        })
                        this.tableData = res.data.content
                        this.total = Number(res.data.totalElements)
                    }else {
                        this.$message.error("获取失败");
                    }
                }).catch(() => {
                    this.$message.error("获取失败");
                });
            },

            refresh() { // 刷新列表
                // this.addOrEdit()
            },
            doSubmit: function (e) {
                let sortParams = {
                    areaCode: this.areaCode,
                    destinationTypeId: this.addType,
                    destinationId:this.id,
                    recommendThematicDTOList: this.recommendThematicDTOList
                };
                if(this.recommendThematicDTOList.length === 0){
                    this.$message.error('请至少选择一项');
                }else {
                    this.request.post("/wtcp-selftourism/selfDestinationInfo", sortParams).then(res => {
                        if (res.status === 1) {
                            this.$emit('doRefresh')
                            this.$message.success("添加成功");
                        } else {
                            this.$message.error(res.msg);
                        }
                    }).catch(() => {
                        this.$message.error("获取失败");
                    });
                }

            },
            doClose() { // 取消弹窗
                this.$emit('doRefresh')
            },
            handleChange(val, row) { // 修改权重接口
                console.log(val);
                console.log(row);
            },
            onChangeSort(n, rowData) { // 修改权重请求
                let sortUrl = '/wtcp-selftourism/selfDestinationInfo/updateStarById';
                let sortParams = {"id": rowData.id, "num": n};
                if(n<=5){
                    this.request.putParams(sortUrl,sortParams).then(res=>{
                        if (res.status == 1) {
                        } else {
                            this.$message({
                                message: res.msg,
                                type: "error"
                            });
                        }
                    });
                }else {
                    this.$message({
                        message: '推荐指数不能超过5',
                        type: "error"
                    });
                }
            },
            currentChange(n) { // 分页
                this.page = n
                this.getListData('searchDatas')
            },
            getListData(searchDatas) { // 搜索接口
                this.$refs[searchDatas].validate((valid) => {
                    if (valid) {
                        this.addOrEdit()
                    } else {
                        return false;
                    }
                });
            },

            //处理选择的表格项
            handleSelectionChange(val) {
                let arr = val.map(item => {
                    return {
                        recommendStar: item.num,
                        thematicId: item.id
                    }
                })
                this.recommendThematicDTOList = arr
            },

            /*标签接口*/
            loadOptions({action, parentNode, callback}) {
                if (action == "LOAD_CHILDREN_OPTIONS") {
                    switch (parentNode.id) {
                        case "success": {
                            simulateAsyncOperation(() => {
                                parentNode.children = [
                                    {
                                        id: "child",
                                        label: "Child option"
                                    }
                                ];
                                callback();
                            });
                            break;
                        }
                        case "no-children": {
                            simulateAsyncOperation(() => {
                                parentNode.children = [];
                                callback();
                            });
                            break;
                        }
                        case "failure": {
                            simulateAsyncOperation(() => {
                                callback(
                                    new Error(
                                        "Failed to load options: network error."
                                    )
                                );
                            });
                            break;
                        }
                        default: /* empty */
                    }
                }
            },
            getNoteTags() {
                let _this = this;
                _this.request
                    .get("/wtcp-traveltips/noteTags/getTagsByKind", {kind: 1})
                    .then(res => {
                        if (res.status == 1) {
                            _this.tagsOptions = res.data.filter(item => {
                                return item.children != null;
                            })
                        }
                    })
                    .catch(error => {
                        console.log(error);
                    });
            },
            treeSelected(node, instanceId) {
                this.tagSelectFlag = true;
                this.selectedNode = node;
            },
            noteTagsChanges(node) {
                if (this.searchDatas.tags && this.searchDatas.tags.length > 4) {
                    for (var a in this.searchDatas.tags) {
                        if (this.searchDatas.tags[a].name == this.selectedNode.name) {
                            this.searchDatas.tags.splice(a, 1);
                        }
                    }
                    this.$message.error("最多允许选择4个标签");
                    this.selectedNode = null;
                }
            },
            /*标签接口*/

            beforeClearAll() {
                this.searchDatas.tags = null;
                return true;
            },
        },
        created: function () {
            this.request.oprahfun(this);
            this.addOrEdit()
            this.getNoteTags();
        },
        watch: {}
    };
</script>
<style lang="less" scoped>
    .search {
        height: 70px;
    }

    .btn {
        height: 80px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
</style>
<style lang="less">
    .travel {
        .search {
            .el-input__inner {
                width: 250px;
                height: 30px;
                line-height: 30px;
            }

            .el-button {
                padding: 0;
                height: 30px;
                width: 80px;

            }
        }
        .el-form-item__content {
            line-height: 20px;
        }
        .vue-treeselect--has-value .vue-treeselect__multi-value{
            margin-top: 0;
        }
        .vue-treeselect__control{
            height: 30px;
        }
        .el-form-item__label{
            /*line-height: 50px;*/
        }
    }
</style>